import {Component, Injector} from '@angular/core';
import {ExpressionState, Store as ExpressionStore} from './state/store';
import {Expression} from './state/model';
import {ExpressionService as ExpressionService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {ExpressionQuery} from './state/query';
import { TranslocoService } from '@ngneat/transloco';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getIDType } from '@datorama/akita';
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: 'detail.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class ExpressionDetailComponent extends EntityDetailComponent<Expression, ExpressionState, ExpressionStore> {

  private key = '';

  constructor(
    public injector: Injector,
    service: ExpressionService,
    protected translationService: TranslocoService,
    protected query: ExpressionQuery,
    protected formBuilder: FormBuilder,
    protected route: ActivatedRoute) {
    super(injector, service, query);

    this.entity$ = of('').pipe(
      switchMap(() =>
      this.route.params.pipe(switchMap((params) => {
      this.id = params.id ?? 'create';
      if (this.id !== '' && this.id !== 'create') {

        if (!this.entityPipe) {
          this.entityPipe = this.service.get(this.id as getIDType<ExpressionState>).pipe(
            //first(),
            map(items => items.length > 0 ? items[0] : (undefined as Expression)),
            map(item => {
              this.key = item.title as string;
              return new Expression({
              id: item.id,
              title: item.title,
              translation: this.translationService.translate(item.title as string),
              createdAt: item.createdAt,
              updatedAt: item.updatedAt
              });
            })
          );
        }

        return this.entityPipe;
      }

      return of(new Expression({}));
    }))));
  }

  prePersist(entity: Expression) {
    this.translationService.setTranslationKey(this.key, entity.translation as string);
    entity.title = entity.translation as string;
  }

  navigateToParent($updated: boolean = false) {
    if ($updated) {
      this.router.navigate(['..'], {relativeTo: this.route});
    } else {
      this.router.navigate(['..'], {relativeTo: this.route});
    }
  }
}
